import React, { createContext } from "react";
import DataStore from "../../logged_in/shared/stores/DataStore/DataStore";
// Context to contain device width
export const DeviceWidthContext = createContext(0);
export const DataStoreContext = createContext<DataStore>(new DataStore());
